import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface themeState {
  mode: string;
}

const initialState: themeState = {
  mode: "dark",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    changeMode: (state) => {
      state.mode === "light" ? (state.mode = "dark") : (state.mode = "light");
    },
    setMode: (state, action: PayloadAction<string>) => {
      state.mode = action.payload;
    },
  },
});

export const { changeMode, setMode } = themeSlice.actions;
export default themeSlice.reducer;
